import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoutUseCase } from '../../features/auth';
import { AuthStorage } from '../../features/auth/infrastructure/authStorage';
import { useSidebar } from './SidebarContext';
import * as S from './ProfileMenu.styles';
import { S3Icon } from '../../shared/ui';


export const ProfileMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [username, setUsername] = useState<string>('');
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { expanded } = useSidebar();

  useEffect(() => {
    const authStorage = new AuthStorage();
    const user = authStorage.getUser();
    if (user?.username) {
      setUsername(user.username);
    } else if (user?.email) {
      setUsername(user.email);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogout = async () => {
    const logoutUseCase = new LogoutUseCase();
    await logoutUseCase.execute();
    navigate('/login', { replace: true });
  };

  const handleSettings = () => {
    setIsOpen(false);
    navigate('/settings');
  };

  const buttonRef = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && buttonRef.current && dropdownRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      dropdownRef.current.style.left = `${rect.left}px`;
      dropdownRef.current.style.bottom = `${window.innerHeight - rect.top + 8}px`;
    }
  }, [isOpen, expanded]);

  return (
    <S.ProfileMenuContainer ref={menuRef}>
      <S.ProfileButton ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
        <S.ProfileAvatar>
          <S.ProfileAvatarPlaceholder>
            <S3Icon iconName="User" width={22} height={22} />
          </S.ProfileAvatarPlaceholder>
        </S.ProfileAvatar>
        {expanded && <S.ProfileLabel>{username || 'Профиль'}</S.ProfileLabel>}
      </S.ProfileButton>
      
      {isOpen && (
        <S.DropdownMenu ref={dropdownRef}>
          <S.DropdownMenuItem onClick={handleSettings}>
            Настройки
          </S.DropdownMenuItem>
          <S.DropdownMenuItem onClick={handleLogout}>
            Выйти
          </S.DropdownMenuItem>
        </S.DropdownMenu>
      )}
    </S.ProfileMenuContainer>
  );
};

